<script>
import { useThemeStore } from "@/store/theme";
import { toRef } from "vue";

export default {
  name: "ThemeToggle",
  setup() {
    const themeStore = useThemeStore();
    return { isDark: toRef(themeStore, "isDark"), toggleTheme: themeStore.toggleTheme };
  },
};
</script>

<template>
  <button class="themeToggle" @click="toggleTheme" :aria-label="isDark ? 'Переключить на светлую тему' : 'Переключить на тёмную тему'">
    <svg v-if="isDark" class="themeToggle__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="5"/>
      <line x1="12" y1="1" x2="12" y2="3"/>
      <line x1="12" y1="21" x2="12" y2="23"/>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
      <line x1="1" y1="12" x2="3" y2="12"/>
      <line x1="21" y1="12" x2="23" y2="12"/>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </svg>
    <svg v-else class="themeToggle__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
  </button>
</template>

<style scoped lang="scss">
.themeToggle {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 12px;
  background: var(--cd-button-bg-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;

  &:hover {
    background: var(--cd-button-bg-color);
    opacity: 0.8;
  }
}

.themeToggle__icon {
  color: var(--cd-highlight-text);
  transition: color 0.3s ease;
}
</style>
